import { Meta, Title } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core'; 
import {Router} from '@angular/router';
import {SiteuserService} from './services/siteuser.service';
import { CanonicalService } from './services/canonical.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  //title = 'sajway-front';
  isloggedin:boolean;
  logintext:string = 'Test';

  constructor(private usrObj:SiteuserService, 
    private router:Router,private title: Title,private meta: Meta,
    private canonicalService: CanonicalService) {}

  ngOnInit(): void {
    this.canonicalService.setCanonicalURL();
    this.meta.addTags([
      //{ name: 'keywords', content: 'Angular SEO Integration, Music CRUD, Angular Universal' },
      
    ]);

    if(this.usrObj.loggedIn() == false){
      this.isloggedin = false;
    }else{
      this.isloggedin = true;
    }
  }

}
